/*!
 * ASP.NET SignalR JavaScript Library 2.4.2
 * http://signalr.net/
 *
 * Copyright (c) .NET Foundation. All rights reserved.
 * Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *
 */

/// <reference path="..\..\SignalR.Client.JS\Scripts\jquery-1.6.4.js" />
/// <reference path="jquery.signalR.js" />
(function ($, window, undefined) {
    /// <param name="$" type="jQuery" />
    "use strict";

    if (typeof ($.signalR) !== "function") {
        throw new Error("SignalR: SignalR is not loaded. Please ensure jquery.signalR-x.js is referenced before ~/signalr/js.");
    }

    var signalR = $.signalR;

    function makeProxyCallback(hub, callback) {
        return function () {
            // Call the client hub method
            callback.apply(hub, $.makeArray(arguments));
        };
    }

    function registerHubProxies(instance, shouldSubscribe) {
        var key, hub, memberKey, memberValue, subscriptionMethod;

        for (key in instance) {
            if (instance.hasOwnProperty(key)) {
                hub = instance[key];

                if (!(hub.hubName)) {
                    // Not a client hub
                    continue;
                }

                if (shouldSubscribe) {
                    // We want to subscribe to the hub events
                    subscriptionMethod = hub.on;
                } else {
                    // We want to unsubscribe from the hub events
                    subscriptionMethod = hub.off;
                }

                // Loop through all members on the hub and find client hub functions to subscribe/unsubscribe
                for (memberKey in hub.client) {
                    if (hub.client.hasOwnProperty(memberKey)) {
                        memberValue = hub.client[memberKey];

                        if (!$.isFunction(memberValue)) {
                            // Not a client hub function
                            continue;
                        }

                        // Use the actual user-provided callback as the "identity" value for the registration.
                        subscriptionMethod.call(hub, memberKey, makeProxyCallback(hub, memberValue), memberValue);
                    }
                }
            }
        }
    }

    $.hubConnection.prototype.createHubProxies = function () {
        var proxies = {};
        this.starting(function () {
            // Register the hub proxies as subscribed
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, true);

            this._registerSubscribedHubs();
        }).disconnected(function () {
            // Unsubscribe all hub proxies when we "disconnect".  This is to ensure that we do not re-add functional call backs.
            // (instance, shouldSubscribe)
            registerHubProxies(proxies, false);
        });

        proxies['SSP1126HUB'] = this.createHubProxy('SSP1126HUB'); 
        proxies['SSP1126HUB'].client = { };
        proxies['SSP1126HUB'].server = {
            Bill: function (billId, paymentId, additionalData, referenceData) {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["Bill"], $.makeArray(arguments)));
             },

            Initial: function (MediaType, IP, COM, AccountType, Language, Timeout) {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["Initial"], $.makeArray(arguments)));
             },

            MciBill: function (MciNumber, BillType, additionalData, referenceData) {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["MciBill"], $.makeArray(arguments)));
             },

            MciInquery: function (MciNumber, BillType) {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["MciInquery"], $.makeArray(arguments)));
             },

            Request: function (requestCode) {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["Request"], $.makeArray(arguments)));
             },

            Reset: function () {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["Reset"], $.makeArray(arguments)));
             },

            SendAmount1Step: function (mainAmount, amounts, additionalData, referenceData, PurchaseID, TerminalID) {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["SendAmount1Step"], $.makeArray(arguments)));
             },

            SendAmount2Step: function (mainAmount, amounts, additionalData, referenceData, purchaseType, PurchaseID, TerminalID) {
                return proxies['SSP1126HUB'].invoke.apply(proxies['SSP1126HUB'], $.merge(["SendAmount2Step"], $.makeArray(arguments)));
             }
        };

        return proxies;
    };

    signalR.hub = $.hubConnection("/signalr", { useDefaultPath: false });
    $.extend(signalR, signalR.hub.createHubProxies());

}(window.jQuery, window));
